import { Grid } from "@mui/material";
import { formatPersianDate } from "../../../utils/date";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";
import { useContext, useEffect, useMemo, useState } from "react";

//import general components
import BaseTable from "../../common/base-table/base-table";

//import images and icons
import { Buliding } from "iconsax-react";

//import styles
import "./confirm.scss";

function HotelInformation() {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //sessionStorage variables
    const selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel"));
    const selectedRooms = JSON.parse(sessionStorage.getItem("selectedRooms"));
    const hotelInformation = JSON.parse(sessionStorage.getItem("hotelInformation"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));

    //table's columns
    const columns = useMemo(() => [
        {
            accessorKey: "name",
            header: `${t("hotel")}`,
            enableSorting: false,
        },
        {
            accessorKey: "rooms",
            header: `${t("rooms")}`,
            enableSorting: false,
        },
        {
            accessorKey: "date",
            header: `${t("checkInCheckOutDate")}`,
            enableSorting: false,
        },
    ]);

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: "long",
        });
    };

    //table's rows
    const [rows, setRows] = useState([]);
    useEffect(() => {
        if (!!hotelInformation && !!selectedHotel && !!selectedRooms) {
            setRows(
                selectedRooms?.map(room => ({
                    name: selectedHotel?.name,
                    rooms: room?.name,
                    date:
                        locale === "en"
                            ? hotelInformation.checkIn + t("to-2") + hotelInformation.checkOut
                            : formatDate(hotelInformation.checkIn) + " " + t("to-2") + "  " + formatDate(hotelInformation.checkOut),
                })),
            );
        }
        if (!!hotelInformation && !!selectedIntRooms) {
            setRows(
                Object.values(selectedIntRooms.rooms)?.map(room => ({
                    name: selectedIntRooms?.name,
                    rooms: room?.name,
                    date: formatDate(hotelInformation.checkIn) + " " + t("to-2") + " " + formatDate(hotelInformation.checkOut),
                })),
            );
        }
    }, []);

    return (
        <Grid container item xs={12} justifyContent="center">
            <Grid className="confirm__title" container item xs={6} justifyContent="center">
                <Buliding color="var(--light-color)" variant="Bold" /> {t("hotel")}
            </Grid>

            <Grid className="confirm" container item xs={12} justifyContent="space-between" alignItems="flex-start">
                <BaseTable columns={columns} rows={rows} details={false} action={false} rowBackground="var(--white-gray-color)" />
            </Grid>
        </Grid>
    );
}

export default HotelInformation;
